// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"_5DA-XfP4","link":"_5D3zj4nk","level":"_5DoVoyWy"};